import request from '@/utils/request'

// 分页查询出租记录信息
export function getPageList(params) {
  return request({
    url: '/hrApi/rentRecord',
    method: 'get',
    params: params
  })
}

// 获取出租记录列表
export function getList(params) {
  return request({
    url: '/hrApi/rentRecord/list',
    method: 'get',
    params: params
  })
}

// 新增或编辑出租记录
export function saveOrUpdateData(data) {
  return request({
    url: '/hrApi/rentRecord',
    method: 'post',
    data: data
  })
}

// 删除出租记录
export function deleteData(id) {
  return request({
    url: '/hrApi/rentRecord/' + id,
    method: 'delete'
  })
}

// 退租
export function breakRecord(data) {
  return request({
    url: '/hrApi/rentRecord/break',
    method: 'put',
    data: data
  })
}

// 检查是否存在未到期合同
export function checkPrevious(id) {
  return request({
    url: '/hrApi/rentRecord/room/' + id,
    method: 'get'
  })
}

// 续签
export function continueRent(data) {
  return request({
    url: '/hrApi/rentRecord/continue',
    method: 'post',
    data: data
  })
}


// 获取详情
export function getById(id) {
  return request({
    url: '/hrApi/rentRecord/' + id,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/rentRecord.js